import styled from "styled-components/macro";
import { PRICING_MOBILE_BREAKPOINT } from "../constants";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  z-index: 9;
`;

export const Container = styled.div`
  margin: auto;
  width: 750px;
  background: white;
  position: relative;
  min-height: 450px;
  max-height: 90vh;
  overflow-y: auto;
  z-index: 10;
  padding: 20px;
  border-radius: 30px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: space-around;

  .close {
    position: absolute;
    right: 30px;
    top: 30px;
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-self: center;
    width: 450px;
    text-align: center;

    h1 {
      text-align: center;
      font-family: "GT Super Text";
      font-size: 24px;
    }

    button {
      background: #25ce93;
      border-radius: 10px;
      font-size: 16px;
      color: #fff;
      border: 0;
      border-radius: 20px;
      font-family: Inter;
      font-weight: 500;
      padding: 10px 40px;
      cursor: pointer;
      margin-top: 15px;
      border: 1px solid #25ce93;

      &:hover {
        background: none;
        color: #25ce93;
      }
    }

    p {
      min-height: 120px;
    }

    ul {
      list-style-type: disc;

      li {
        list-style-type: disc;
        text-align: left;
        color: #444;
        line-height: 1.3em;
        margin-bottom: 15px;
      }
    }
  }

  @media screen and (max-width: ${PRICING_MOBILE_BREAKPOINT}) {
    flex-direction: column;
    width: 80%;
    min-height: 780px;
    max-height: 90vh;
    overflow-y: auto;
  }
`;

export const ComparisonSection = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 12px 16px;
  background: #f7f8fa;
  border-radius: 10px;
  width: 100%;
  text-align: left;
  font-size: 14px;
  line-height: 1.5em;
  color: #444;
  font-variant-numeric: tabular-nums;

  p {
    margin: 4px 0;
    min-height: unset !important;
  }

  strong {
    color: #222;
  }
`;

export const RolloverWarning = styled.div`
  margin-top: 8px;
  padding: 12px 16px;
  background: #fff8e6;
  border-radius: 10px;
  font-size: 13px;
  line-height: 1.4em;
  color: #665522;
  width: 100%;
  text-align: left;
  margin-bottom: 10px;
`;

export const RolloverBenefit = styled.div`
  margin-top: 8px;
  padding: 12px 16px;
  background: #e8f8f0;
  border-radius: 10px;
  font-size: 13px;
  line-height: 1.4em;
  color: #225544;
  width: 100%;
  text-align: left;
  margin-bottom: 10px;
`;
